import React from 'react';
import type { SiteUrl } from '../types';

interface BottomBarGridProps {
    bottomBarGridItems: SiteUrl[];
}

function BottomBarGrid({ bottomBarGridItems }: BottomBarGridProps) {
    return (
        <div className="bottomBarLogoGrid">
            {
                bottomBarGridItems.map((item, index) => (
                    <div key={`${item.text}-${index}`} className="logoGridItem">
                        <div>
                            {item.logo ? item.logo : null}
                        </div>
                        <div>
                            {item.url ? (
                                <a href={item.url} aria-label={item.text}>
                                    {item.text}
                                </a>
                            ) : (
                                <span>{item.text}</span>
                            )}
                        </div>
                    </div>))
            }
        </div>
    );
}

export default BottomBarGrid;
